// Shared collapse/disclosure animation timing for reasoning/tool-call
// components (reasoning.tsx, tool-group.tsx, tool-fallback.tsx). Mirrors the
// CSS `duration-collapse`/`ease-collapse` theme tokens in tailwind.css — this
// constant is the JS-side counterpart for callers (useScrollLock) that need
// the raw millisecond number rather than a CSS class.
export const COLLAPSE_ANIMATION_MS = 200;
